// Safe alternative to `printWindow.document.write(...)`.
// Renders the given HTML by loading it from a Blob URL, so the browser
// parses it from a static resource instead of an interpreter-writable
// document stream. This avoids the `document.write` XSS surface flagged
// by the code review while preserving the auto-print behavior.
export function openPrintWindow(html, { autoPrint = true } = {}) {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (!printWindow) {
    URL.revokeObjectURL(url);
    return null;
  }
  const cleanup = () => {
    try { URL.revokeObjectURL(url); } catch (e) { /* noop */ }
  };
  if (autoPrint) {
    const doPrint = () => {
      try {
        printWindow.focus();
        printWindow.print();
      } catch (e) {
        console.warn('openPrintWindow: print() failed', e);
      }
    };
    printWindow.addEventListener('load', doPrint, { once: true });
    // Revoke well after the print dialog has had time to open
    setTimeout(cleanup, 60000);
  } else {
    setTimeout(cleanup, 60000);
  }
  return printWindow;
}
